import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _toArray from "@babel/runtime/helpers/toArray";
import { Document, Block } from 'slate';
export function normalizeNode(rawType) {
  var rules = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var types = new Set(Array.isArray(rawType) ? rawType : [rawType]);
  return {
    normalizeNode: function normalizeNode(originalNode, editor, next) {
      if (!types.has(originalNode.type)) {
        return next();
      }

      rules.forEach(function (rule) {
        var node = editor.value.document.getNode(originalNode.key);
        if (!node) return;

        var _ref = Array.isArray(rule) ? rule : [rule],
            _ref2 = _toArray(_ref),
            normalizer = _ref2[0],
            args = _ref2.slice(1);

        normalizer.apply(void 0, [node, editor].concat(_toConsumableArray(args)));
      });
      return next();
    }
  };
}
export function shouldBeAtRoot(node, editor) {
  var parent = editor.value.document.getParent(node.key);

  while (parent && !Document.isDocument(parent)) {
    editor.unwrapNodeByKey(node.key);
    parent = editor.value.document.getParent(node.key);
  }
}
export function shouldBeAtomic(node, editor) {
  if (!node.getIn(['data', 'atomic'])) {
    editor.setNodeByKey(node.key, {
      data: node.data.set('atomic', true)
    });
  }
}
export function shouldNotBeEmpty(node, editor) {
  if (node.nodes.isEmpty()) {
    editor.removeNodeByKey(node.key);
  }
}
export function shouldHaveText(node, editor) {
  if (node.text.length === 0) {
    editor.removeNodeByKey(node.key);
  }
}
export function shouldHaveParentOfType(node, editor, type) {
  var parent = editor.value.document.getParent(node.key);

  if (!parent || parent.type !== type) {
    while (parent && !Document.isDocument(parent) && parent.type !== type) {
      editor.unwrapNodeByKey(node.key);
      parent = editor.value.document.getParent(node.key);
    }

    editor.wrapBlockByKey(node.key, type);
  }
}
export function shouldHaveChildrenOfType(node, editor, type) {
  var children = node.nodes.filter(function (child) {
    return child.type !== type;
  });

  if (!Block.isBlockList(children) && node.text.length > 0) {
    // This node only contains inlines block and text, and should be converted
    // into it's expected children type
    var path = editor.value.document.getPath(node.key);
    var block = Block.create({
      type: type,
      nodes: node.nodes
    });
    editor.replaceNodeByPath(path, block).wrapNodeByPath(path, node);
    return;
  } // All nodes should be kicked out


  children.forEach(function (child) {
    return editor.unwrapNodeByKey(child.key);
  });
  children.forEach(function (child) {
    return child.normalize(editor.controller, node);
  });
}
export function shouldMergeWithSimilarSiblings(node, editor) {
  var comparator = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function (a, b) {
    return a.type === b.type;
  };
  var nextNode = editor.value.document.getNextSibling(node.key);

  if (nextNode && comparator(node, nextNode)) {
    editor.mergeNodeByKey(nextNode.key);
  }

  var previousNode = editor.value.document.getPreviousSibling(node.key);

  if (previousNode && comparator(node, previousNode)) {
    editor.mergeNodeByKey(node.key);
  }
}